(function() {
	'use strict';

	angular.module('quantixApp').controller(
			'ProjectionsAndFinancialDisplayController', ProjectionsAndFinancialDisplayController);

	ProjectionsAndFinancialDisplayController.$inject = ['$rootScope','$scope','GenericServiceNew','ProjectionAndFinancialDisplayService','$timeout'];

	function ProjectionsAndFinancialDisplayController($rootScope,$scope,GenericServiceNew,ProjectionAndFinancialDisplayService,$timeout) {
		$rootScope.homePageMenuStatus=false;
		$rootScope.bm=false;
        $rootScope.qst=false;
        $rootScope.score=false;
        $rootScope.sme=false;
        $rootScope.fsm=false;
		$rootScope.home=false;
		$rootScope.projections=true;
		$scope.companySelect=false;
		$scope.viewCrisilSum=false;
		$scope.viewCrisilDetails=false;
		$scope.viewCrisilCRR=false;
		$scope.viewCrisilCMA=false;
		$scope.viewIntrim=false;
		var spread;
		$scope.tabView=false;
		$scope.subTab=false;
		$scope.IsConsolidated=false;
		$scope.IsStandAlone=false;
		$scope.statusFlag='N';
		
		$scope.searchFilterForProjection = function(typedthings) {
			// when $watch is executing companyCode is null , it will be get
			// after selecting a company
			$scope.selected = true;
			$scope.companyCode = "";

			if (typedthings == "cleanData") {
				$scope.companies = null;

			} else {
				GenericServiceNew
						.getCompaniesListByNameNew(typedthings,"")
						.then(
								function(data) {



									$scope.companies = data;
									
									if ($scope.companies.length == 0) {
										$scope.error = true;
										$scope.showError = true;
										$scope.errorMessages="No records match the text entered, please change your selection.";
									
										$timeout(function(){

											$scope.error = false;
											$scope.showError = false;
											$scope.errorMessages = "";

										},2000);
									}

								}, function(errordata) {
								});
			}

		}
		
		// select company from filtered list
		$scope.selectCompany = function(companyObj) {
			$scope.selected = true;
			$scope.companyCode = companyObj.companyCode;			
		}
		
	
		
		$scope.getcrisilDetailData=function(searchText){	
			$scope.text=searchText;
		    var search=$scope.text;
			var message="";
			var formula="";
			var newFormula="";
			var array="";
			var colHeader='';
			var header='';
			$timeout(function(){	
				if($scope.data.yearListdata.length<1)
    			{
					$('#projectionTemplate').empty();
					$scope.error=true;
	    			$scope.errorMessages="No data found.";
    			    return;
    			}
			$('#projectionTemplate').empty();
			spread = new GC.Spread.Sheets.Workbook(document.getElementById('projectionTemplate'));
			spread.options.allowCopyPasteExcelStyle = false;
			spread.options.newTabVisible = false;
			var sheet = spread.getActiveSheet();
			spread.suspendPaint();
			var rowcount = sheet.getRowCount();
			var colcount = sheet.getColumnCount();
			sheet.deleteRows(0, rowcount);
			sheet.deleteColumns(0, colcount);
			sheet.addRows(0, $scope.data.params.length);
			sheet.addColumns(0,($scope.data.yearListdata.length)+2)
			var columnHeader=sheet.getValue(0, ($scope.data.yearListdata.length), GcSpread.Sheets.SheetArea.colHeader);
			sheet.setArray(0,0,$scope.data.params,false);

			
		
								
			sheet.setColumnWidth(0, 400);			 
	        spread.options.resizeZeroIndicator = GC.Spread.Sheets.ResizeZeroIndicator.enhanced;
	     	var lineStyle = GC.Spread.Sheets.LineStyle.thin;
			var lineBorder = new GC.Spread.Sheets.LineBorder('GREY', lineStyle);					
			var sheetArea = GC.Spread.Sheets.SheetArea.viewport;
			var style =new GC.Spread.Sheets.Style();
			
			sheet.setRowCount(2, GcSpread.Sheets.SheetArea.colHeader);

            sheet.addSpan(0, 1, 1,($scope.data.yearListdata.length)+1, GcSpread.Sheets.SheetArea.colHeader);
            sheet.getCell(0, 1, GcSpread.Sheets.SheetArea.colHeader).value("Historical");
            sheet.getCell(1, 0, GcSpread.Sheets.SheetArea.colHeader).value("");
            
            for(var i=0;i<=$scope.data.yearListdata.length;i++)
            	{
            	  sheet.getCell(1, i+1, GcSpread.Sheets.SheetArea.colHeader).value($scope.data.yearListdata[i]);
            	}

            sheet.getCell(1, ($scope.data.yearListdata.length)+1, GcSpread.Sheets.SheetArea.colHeader).value("% of Total");

            var headerStyle = new GcSpread.Sheets.Style();
            headerStyle.backColor = "Gray";
            headerStyle.foreColor = "White";
            headerStyle.hAlign = GcSpread.Sheets.HorizontalAlign.center;
            headerStyle.vAlign = GcSpread.Sheets.VerticalAlign.center;

           for (var i = 0; i < sheet.getColumnCount() ; i++) {
            	sheet.setColumnWidth(i+1, 90.0,GcSpread.Sheets.SheetArea.colHeader);
                sheet.setStyle(0, i, headerStyle, GcSpread.Sheets.SheetArea.colHeader);
                sheet.setStyle(1, i, headerStyle, GcSpread.Sheets.SheetArea.colHeader);
           }
           
           for(var yearCount=0; yearCount<$scope.data.yearListdata.length;yearCount++)
        	   {
	        	   for(var i = 0; i < $scope.data.allData[$scope.data.yearListdata[yearCount]].length ; i++)
	        	   {
	        	       sheet.setValue(i, yearCount+1, $scope.data.allData[$scope.data.yearListdata[yearCount]][i]);
	        	   }
        	   }
            
        //formatting
          for(var colCount=1;colCount<=$scope.data.yearListdata.length;colCount++)
        	  {
                sheet.getColumn(colCount).formatter("#,##0.##");
			  }
          
          sheet.getColumn($scope.data.yearListdata.length+1).formatter("#,##0.#");
          //end formatting
      	
			
			//Formulas  
			 for(var rowCount=1; rowCount<34;rowCount++)
				 {
				 sheet.setFormula(rowCount, ($scope.data.yearListdata.length)+1, "=("+columnHeader+(rowCount+1).toString() + "/"+columnHeader +"34)*100");
				 
				 }
			 
			 for(var rowCount=34; rowCount<63;rowCount++)
			 {
			 sheet.setFormula(rowCount, ($scope.data.yearListdata.length)+1, "=IFERROR(("+columnHeader+(rowCount+1).toString() + "/"+columnHeader +"63)*100,0)");
			 
			 }
          
			 for(var rowCount=72; rowCount<76;rowCount++)
			 {
			 sheet.setFormula(rowCount, ($scope.data.yearListdata.length)+1, "=IFERROR(("+columnHeader+(rowCount+1).toString() + "/"+columnHeader +"76)*100,0)");
			 
			 }
			 for(var rowCount=77; rowCount<108;rowCount++)
			 {
			 sheet.setFormula(rowCount, ($scope.data.yearListdata.length)+1, "=IFERROR(("+columnHeader+(rowCount+1).toString() + "/"+columnHeader +"76)*100,0)");
			 
			 }
			 for(var rowCount=231; rowCount<241;rowCount++)
			 {
			 sheet.setFormula(rowCount, ($scope.data.yearListdata.length)+1, "=IFERROR(("+columnHeader+(rowCount+1).toString() + "/"+columnHeader +"241)*100,0)");
			 
			 }
			 //end formulas
			 
			//backend Formulas
			    colHeader='A';
				header='#';
				for(var colCount=1;colCount<=$scope.data.yearListdata.length;colCount++)
					{
					colHeader=String.fromCharCode(colHeader.charCodeAt() + 1);

					for(var i=0;i<=$scope.data.formulas.length;i++)
					{
					if($scope.data.formulas[i]!=null && $scope.data.formulas[i]!='')
						{	
						
						formula=$scope.data.formulas[i].toString();
						newFormula=formula.replace(new RegExp(header, 'g'),colHeader);
						$scope.data.formulas[i]=newFormula;		
						}				  
					}
					
					header=colHeader;
				    sheet.setArray(0,colCount,$scope.data.formulas,true);
				
					}
				//end backend formulas
          
            
            for(var i=0;i<$scope.data.hirachy.length;i++){

				var substrings = $scope.data.hirachy[i].split(".");
				if(substrings.length - 1 == 0){
					var style =new GC.Spread.Sheets.Style();
					//var array = (data.style[i]+"").split(',');
					style.backColor = '#D8D8D8';
					style.foreColor = '#525252';
					style.font = 'bold'+" "+"10pt Arial";
					sheet.setStyle(i, -1, style);
					sheet.getCell(i,0).textIndent(0);
				}else if(substrings.length - 1 == 1){
					/*var style =new GC.Spread.Sheets.Style();
					var array = (data.style[i]+"").split(',');
					style.backColor = array[2];
					style.foreColor = array[3];
					style.font = array[4]+" "+array[0]+"pt "+array[1];
					sheet.setStyle(i, -1, style);*/
					sheet.getCell(i,0).textIndent(1);
				}else if(substrings.length - 1 == 2){
					/*var style =new GC.Spread.Sheets.Style();
					var array = (data.style[i]+"").split(',');
					style.backColor = array[2];
					style.foreColor = array[3];
					style.font = array[4]+" "+array[0]+"pt "+array[1];
					sheet.setStyle(i, -1, style);*/
					var style =new GC.Spread.Sheets.Style();
					style.backColor = '#F2F2F2';
					style.foreColor = '#0070c0';
					style.font = 'italic'+" "+"10pt Arial";
					sheet.setStyle(i, -1, style);
					sheet.getCell(i,0).textIndent(4);
				}else{
					/*var style =new GC.Spread.Sheets.Style();
					var array = (data.style[i]+"").split(',');
					style.backColor = array[2];
					style.foreColor = array[3];
					style.font = array[4]+" "+array[0]+"pt "+array[1];
					sheet.setStyle(i, -1, style);*/
					sheet.getCell(i,0).textIndent(6);
				}
			}
            
       
			spread.resumePaint();
			var option = {
		            allowFilter: true,
		            allowSort: true,
		            allowResizeRows: true,
		            allowResizeColumns: true,
		            allowEditObjects: true,
		            allowSelectLockedCells:true,
		            allowSelectUnlockedCells:true

		        };
			var searchCondition = new GcSpread.Sheets.SearchCondition();
			searchCondition.searchString =search;
			searchCondition.startSheetIndex = spread.getActiveSheetIndex();
			searchCondition.endSheetIndex = spread.getActiveSheetIndex();
			searchCondition.searchOrder = GcSpread.Sheets.SearchOrder.NOrder;
			searchCondition.searchTarget = GcSpread.Sheets.SearchFoundFlags.CellText;
			searchCondition.searchFlags = GcSpread.Sheets.SearchFlags.Ignorecase| GcSpread.Sheets.SearchFlags.UseWildCards;
			var searchresult= spread.search(searchCondition);
			var verticalPosition = GC.Spread.Sheets.VerticalPosition.top;
			sheet.showRow(searchresult.foundRowIndex, verticalPosition);		
			sheet.options.protectionOptions = option;
			sheet.options.isProtected = true;
			
		},1000);
		}
			
		
		//spread for interim
		
		$scope.getInterimData=function()
		{			
			$('#projectionTemplate').empty();
			$scope.errorMessages="";
			ProjectionAndFinancialDisplayService.getInterimTemplateData($scope.companyCode,$scope.statusFlag).then(function(InterimData) {
				$timeout(function(){
					$scope.error=false;
					$scope.InterimData=InterimData;
					
				},100);
				

    		}, function(errordata) {
    			$scope.error=true;
    			$scope.errorMessages="Oops something went wrong while loading  template.";
    			//return validationError(true,message);
    		});
			
			var message="";
			$timeout(function(){
			$('#projectionTemplate').empty();
			spread = new GC.Spread.Sheets.Workbook(document.getElementById('projectionTemplate'));
			spread.options.allowCopyPasteExcelStyle = false;
			spread.options.newTabVisible = false;
			var sheet = spread.getActiveSheet();
			spread.suspendPaint();
			var rowcount = sheet.getRowCount();
			var colcount = sheet.getColumnCount();
			sheet.deleteRows(0, rowcount);
			sheet.deleteColumns(0, colcount);
			sheet.addRows(0, $scope.InterimData.yearListdata[0].length);
						
			sheet.addColumns(0, 7);
			
			sheet.setArray(0,0,$scope.InterimData.params,false);
			sheet.setArray(0,1,$scope.InterimData.formulas,true);		
	        spread.options.resizeZeroIndicator = GC.Spread.Sheets.ResizeZeroIndicator.enhanced;
	     	var lineStyle = GC.Spread.Sheets.LineStyle.thin;
			var lineBorder = new GC.Spread.Sheets.LineBorder('GREY', lineStyle);					
			var sheetArea = GC.Spread.Sheets.SheetArea.viewport;

			var style =new GC.Spread.Sheets.Style();
			
			sheet.setRowCount(1, GcSpread.Sheets.SheetArea.colHeader);

            sheet.getCell(0, 0, GcSpread.Sheets.SheetArea.colHeader).value("Parameter");
            sheet.getCell(0, 1, GcSpread.Sheets.SheetArea.colHeader).value("Units");
            sheet.getCell(0, 2, GcSpread.Sheets.SheetArea.colHeader).value($scope.InterimData.yearListdata[0]);
            sheet.getCell(0, 3, GcSpread.Sheets.SheetArea.colHeader).value($scope.InterimData.yearListdata[1]);
            sheet.getCell(0, 4, GcSpread.Sheets.SheetArea.colHeader).value($scope.InterimData.yearListdata[2]);
            sheet.getCell(0, 5, GcSpread.Sheets.SheetArea.colHeader).value("QoQ Growth (%)");
            sheet.getCell(0, 6, GcSpread.Sheets.SheetArea.colHeader).value("YoY Growth (%)");
            
            if($scope.InterimData.SegmentId[0]=="5")
            	{
            	 sheet.setValue(0, 0, "No of months");
                 sheet.setValue(1, 0, "Total Revenue");
                 sheet.setValue(2, 0,"Operating Profit");
                 sheet.setValue(3, 0, "Interest");
                 sheet.setValue(4, 0, "Depreciation");
                 sheet.setValue(5, 0, "Profit before Tax");
                 sheet.setValue(6, 0, "Profit After Tax");
            	}
            else if($scope.InterimData.SegmentId[0]=="8")
            	{
            	sheet.setValue(0, 0, "No of months");
                sheet.setValue(1, 0, "Interest Earned ");
                sheet.setValue(2, 0, "Interest Expended");
                sheet.setValue(3, 0,"Net Interest Income ");
                sheet.setValue(4, 0, "Total Income : Net of Interest Charges");
                sheet.setValue(5, 0, "Profit After Tax");
            	}
            else
            	{
            	 sheet.setValue(0, 0, "No of Months");
                 sheet.setValue(1, 0, "Income From Operations");
                 sheet.setValue(2, 0, "Total Income");
                 sheet.setValue(3, 0, "Interest & Finance Charges");
                 sheet.setValue(4, 0, "Total Income : Net of Interest & Finance Charges");
                 sheet.setValue(5, 0, "Profit After Tax");
            	}            
       
            sheet.setValue(1, 1, "Rs Million");
            sheet.setValue(2, 1, "Rs Million");
            sheet.setValue(3, 1, "Rs Million");
            sheet.setValue(4, 1, "Rs Million");
            sheet.setValue(5, 1, "Rs Million");
            sheet.setValue(6, 1, "Rs Million");

            var headerStyle = new GcSpread.Sheets.Style();
            headerStyle.backColor = "Gray";
            headerStyle.foreColor = "Black";
            headerStyle.hAlign = GcSpread.Sheets.HorizontalAlign.center;
            headerStyle.vAlign = GcSpread.Sheets.VerticalAlign.center;

            for (var i = 0; i < sheet.getColumnCount() ; i++) {
            	sheet.setColumnWidth(i, 130.0,GcSpread.Sheets.SheetArea.colHeader);
                sheet.setStyle(0, i, headerStyle, GcSpread.Sheets.SheetArea.colHeader);
                sheet.setStyle(1, i, headerStyle, GcSpread.Sheets.SheetArea.colHeader);
                var style =new GC.Spread.Sheets.Style();
    			style.font = 'bold'+" "+"10pt Arial";
                sheet.setStyle(i,0, style);
          }
            
        	sheet.setColumnWidth(0, 300);
          for(var i = 0; i < $scope.InterimData.allData[$scope.InterimData.yearListdata[0]].length ; i++){
            	 sheet.setValue(i, 2, $scope.InterimData.allData[$scope.InterimData.yearListdata[0]][i]);
            }
           for(var i = 0; i < $scope.InterimData.allData[$scope.InterimData.yearListdata[1]].length ; i++){
          	 sheet.setValue(i, 3, $scope.InterimData.allData[$scope.InterimData.yearListdata[1]][i]);
          }
           for(var i = 0; i < $scope.InterimData.allData[$scope.InterimData.yearListdata[2]].length ; i++){
          	 sheet.setValue(i, 4, $scope.InterimData.allData[$scope.InterimData.yearListdata[2]][i]);
          }
           for(var i = 1; i < $scope.InterimData.allData[$scope.InterimData.yearListdata[2]].length ; i++){
        	   sheet.setFormula(i, 5, "=(C" + (i+1).toString() + "-D" + (i+1).toString()+ ")/D"+(i+1).toString());
        	   sheet.getRange(i,5).formatter("#,##0.#");
            }
           for(var i = 1; i < $scope.InterimData.allData[$scope.InterimData.yearListdata[2]].length ; i++){
        	   sheet.setFormula(i, 6, "=(C" + (i+1).toString() + "-E" + (i+1).toString()+ ")/E"+(i+1).toString());
        	   sheet.getRange(i,6).formatter("#,##0.#");
            }

			spread.resumePaint();
			var option = {
		            allowFilter: true,
		            allowSort: true,
		            allowResizeRows: true,
		            allowResizeColumns: true,
		            allowEditObjects: true,
		            allowSelectLockedCells:true,
		            allowSelectUnlockedCells:true

		        };			

			sheet.options.protectionOptions = option;
			sheet.options.isProtected = true;
			
		},1000);
			
		}
		
		//spread for CMA
		$scope.getCMAData=function()
		{
			$('#projectionTemplate').empty();
			$scope.errorMessages="";
			
			var message="";
			$timeout(function(){
			$('#projectionTemplate').empty();
			spread = new GC.Spread.Sheets.Workbook(document.getElementById('projectionTemplate'));
			spread.options.allowCopyPasteExcelStyle = false;
			spread.options.newTabVisible = false;
			var sheet = spread.getActiveSheet();
			spread.suspendPaint();
			var rowcount = sheet.getRowCount();
			var colcount = sheet.getColumnCount();
			sheet.deleteRows(0, rowcount);
			sheet.deleteColumns(0, colcount);						
			sheet.addColumns(0, ($scope.data.yearListdata.length)+2);
			sheet.setColumnWidth(0, 50);
			sheet.setColumnWidth(1, 400);
			sheet.addRows(0, $scope.data.params.length);
			sheet.setArray(0,1,$scope.data.params,false);
			sheet.setArray(0,0,$scope.data.columnName,false);

	        spread.options.resizeZeroIndicator = GC.Spread.Sheets.ResizeZeroIndicator.enhanced;
	     	var lineStyle = GC.Spread.Sheets.LineStyle.thin;
			var lineBorder = new GC.Spread.Sheets.LineBorder('GREY', lineStyle);					
			var sheetArea = GC.Spread.Sheets.SheetArea.viewport;

			var style =new GC.Spread.Sheets.Style();
			
			   sheet.setRowCount(3, GcSpread.Sheets.SheetArea.colHeader);
			   sheet.addSpan(0, 0, 3, 1, GcSpread.Sheets.SheetArea.colHeader);
			   sheet.getCell(0, 0, GcSpread.Sheets.SheetArea.colHeader).value("Sr.No.");
			   sheet.addSpan(0, 1, 3, 1, GcSpread.Sheets.SheetArea.colHeader);
			   sheet.getCell(0, 1, GcSpread.Sheets.SheetArea.colHeader).value("Particulars");
			   
	           sheet.addSpan(0, 2, 1, $scope.data.yearListdata.length, GcSpread.Sheets.SheetArea.colHeader);
	           sheet.getCell(0, 2, GcSpread.Sheets.SheetArea.colHeader).value("Actuals as per audited accounts");
	           
	           for(var i=1;i<=$scope.data.yearListdata.length;i++)
           	{
           	  sheet.getCell(1, i+1, GcSpread.Sheets.SheetArea.colHeader).value($scope.data.yearListdata[i-1]);
           	  sheet.getCell(2, i+1, GcSpread.Sheets.SheetArea.colHeader).value("Year "+i);
           	}
	          
	           
	           //style for main tabs
	           var Tabstyle =new GC.Spread.Sheets.Style();
			   Tabstyle.backColor = '#47ACDF';
			   Tabstyle.foreColor = 'black';
			   Tabstyle.font = 'bold'+" "+"10pt Arial";
	           Tabstyle.hAlign = GcSpread.Sheets.HorizontalAlign.center;
	           Tabstyle.vAlign = GcSpread.Sheets.VerticalAlign.center;
                    
            var headerStyle = new GcSpread.Sheets.Style();
            headerStyle.backColor = "Gray";
            headerStyle.foreColor = "Black";
            headerStyle.hAlign = GcSpread.Sheets.HorizontalAlign.center;
            headerStyle.vAlign = GcSpread.Sheets.VerticalAlign.center;

            for (var i = 2; i < sheet.getColumnCount() ; i++) {
            	sheet.setColumnWidth(i, 130.0,GcSpread.Sheets.SheetArea.colHeader);
                sheet.setStyle(0, i, headerStyle, GcSpread.Sheets.SheetArea.colHeader);
                sheet.setStyle(1, i, headerStyle, GcSpread.Sheets.SheetArea.colHeader);
                var style =new GC.Spread.Sheets.Style();
    			style.font = 'bold'+" "+"10pt Arial";
                sheet.setStyle(i,0, style);
          }
            
            
            for(var yearCount=0; yearCount<$scope.data.yearListdata.length;yearCount++)
     	   {
	        	   for(var i = 0; i < $scope.data.allData[$scope.data.yearListdata[yearCount]].length ; i++)
	        	   {
	        	       sheet.setValue(i, yearCount+2, $scope.data.allData[$scope.data.yearListdata[yearCount]][i]);
	        	   }
     	   }
            
            var style =new GC.Spread.Sheets.Style();
            for(var i=0;i<$scope.data.hirachy.length;i++){          	
				var substrings = $scope.data.hirachy[i].split(".");
				if(substrings.length - 1 == 0)
				{					
					style.backColor = '#3498DB';
					style.foreColor = '#000000  ';
					style.font = 'bold'+" "+"10pt Arial";
					sheet.setStyle(i, 0, style);
					sheet.getCell(i,0).textIndent(0);
				}
				else if(substrings.length - 1 == 1){
					
					sheet.getCell(i,0).textIndent(10);
					style.font = 'bold'+" "+"10pt Arial";
				}
				else if(substrings.length - 1 == 2){
					
					style.backColor = '#F2F2F2';
					style.foreColor = '#0070c0';
					style.font = 'italic'+" "+"10pt Arial";
					sheet.setStyle(i, -1, style);
					sheet.getCell(i,0).textIndent(4);
				}else{
					
					sheet.getCell(i,0).textIndent(6);
				}
			}
         
			spread.resumePaint();
			var option = {
		            allowFilter: true,
		            allowSort: true,
		            allowResizeRows: true,
		            allowResizeColumns: true,
		            allowEditObjects: true,
		            allowSelectLockedCells:true,
		            allowSelectUnlockedCells:true

		        };			

			sheet.options.protectionOptions = option;
			sheet.options.isProtected = true;
			
		},1000);
			
		}
		
		
		$scope.getDetailsView=function(){
			$scope.tabView=true;
			
		}
		
		//radio button
		$scope.getStatusFlag= function(status)	
		{	
			$('#projectionTemplate').empty();	
			$scope.Status=status;
			if($scope.Status=='Standalone')
			{
				$scope.statusFlag='N';
			}
			else if($scope.Status=='Consolidated')
				{
				$scope.statusFlag='Y';
				}
			
				 if($scope.tab=='1'){
					 $scope.subTab=true;
			    		$scope.dataType='Crisil Detail';
			    		ProjectionAndFinancialDisplayService.getHistoricalTemplateData($scope.dataType,$scope.companyCode,$scope.statusFlag).then(function(data) {
							$timeout(function(){						
								$scope.error=false;
								$scope.data=data;
								if($scope.data.yearListdata.length<1)
				    			{
									$('#projectionTemplate').empty();
									$scope.error=true;
					    			$scope.errorMessages="No data found.";
				    			    return;
				    			}
								 $scope.getcrisilDetailData("Profit and loss account");
							},100);
							
			    		}, function(errordata) {
			    			$scope.error=true;
			    			$scope.errorMessages="Oops something went wrong while loading  template.";
			    			//return validationError(true,message);
			    		});
			    	}
			     else if($scope.tab=='2' || $scope.tab=='3'){
			    	 $scope.subTab=true;
			    		$scope.dataType='Crisil Detail,Crisil Sum,CRR';
			    		ProjectionAndFinancialDisplayService.getHistoricalTemplateData($scope.dataType,$scope.companyCode,$scope.statusFlag).then(function(data) {
							$timeout(function(){
								$scope.error=false;
								$scope.data=data;
								if($scope.data.yearListdata.length<1)
				    			{
									$('#projectionTemplate').empty();
									$scope.error=true;
					    			$scope.errorMessages="No data found.";
				    			    return;
				    			}
								 $scope.getcrisilDetailData("Profit and loss account");
							},100);
							

			    		}, function(errordata) {
			    			$scope.error=true;
			    			$scope.errorMessages="Oops something went wrong while loading  template.";
			    			//return validationError(true,message);
			    		});
			    	}
			     else if($scope.tab=='5')
			    	 {
			    	 $scope.getInterimData();
			    	 $scope.subTab=false;
			    	 }
		}


		//deepali
		$scope.setTab = function(newTab){
			$('#projectionTemplate').empty();
		     $scope.tab = newTab;
		     $scope.errorMessages="";
		     if($scope.tab=='1'){
		    	 $scope.subTab=true;
		    		$scope.dataType='Crisil Detail';
		    		ProjectionAndFinancialDisplayService.getHistoricalTemplateData($scope.dataType,$scope.companyCode,$scope.statusFlag).then(function(data) {
						$timeout(function(){						
							$scope.error=false;
							$scope.data=data;
							if($scope.data.yearListdata.length<1)
			    			{
								$('#projectionTemplate').empty();
								$scope.error=true;
				    			$scope.errorMessages="No data found.";
			    			    return;
			    			}
							 $scope.getcrisilDetailData("Profit and loss account");
						},100);
						
		    		}, function(errordata) {
		    			$scope.error=true;
		    			$scope.errorMessages="Oops something went wrong while loading  template.";
		    			//return validationError(true,message);
		    		});
		    		
		    	}
		     else if($scope.tab=='2' || $scope.tab=='3'){
		    		$scope.subTab=true;
		    		$scope.dataType='Crisil Detail,Crisil Sum,CRR';
		    		ProjectionAndFinancialDisplayService.getHistoricalTemplateData($scope.dataType,$scope.companyCode,$scope.statusFlag).then(function(data) {
						$timeout(function(){
							$scope.data=data;
							$scope.error=false;
							if($scope.data.yearListdata.length<1)
			    			{
								$('#projectionTemplate').empty();
								$scope.error=true;
				    			$scope.errorMessages="No data found.";
			    			    return;
			    			}
							 $scope.getcrisilDetailData("Profit and loss account");
							
						},100);
						

		    		}, function(errordata) {
		    			$scope.error=true;
		    			$scope.errorMessages="Oops something went wrong while loading  template.";
		    			//return validationError(true,message);
		    		});
		    	}
		     else if($scope.tab=='4')
		     {
		    	 $scope.subTab=true;
		    	 $scope.dataType='CMA';
		    		ProjectionAndFinancialDisplayService.getHistoricalTemplateData($scope.dataType,$scope.companyCode,$scope.statusFlag).then(function(data) {
						$timeout(function(){
							$scope.data=data;
							$scope.error=false;
							if($scope.data.yearListdata.length<1)
			    			{
								$('#projectionTemplate').empty();
								$scope.error=true;
				    			$scope.errorMessages="No data found.";
			    			    return;
			    			}
							 $scope.getCMAData();
							
						},100);
						

		    		}, function(errordata) {
		    			$scope.error=true;
		    			$scope.errorMessages="Oops something went wrong while loading  template.";
		    			//return validationError(true,message);
		    		});
		    		    		
		    }
		     else if($scope.tab=='5')
		    	 {
		    	 $scope.getInterimData();
		    	 $scope.subTab=false;
		    	 }
		  };

		    $scope.isSet = function(tabNum)
		    {
		    	 return $scope.tab === tabNum;
		    	
		    };
		    //end by Deepali
		
			

		$scope.searchByCompanyProjectionDisplay = function(companyCode,event) 
		{		
			   event.preventDefault();
			   $scope.tabView=false;
			   $scope.subTab=false;
			   $('#projectionTemplate').empty();
			   $scope.isSet(0);
			   if (companyCode != "" && companyCode != null) {
				$('#projectionTemplate').empty();
				$scope.companyCode=companyCode;
				ProjectionAndFinancialDisplayService.getFlagByCompany(companyCode).then(
						function(data) {
							$scope.companySelect=true;
                            $scope.tabView=true;
							if(data.viewCrisilSum == "Y"){
							$scope.viewCrisilSum = true;
							}else{
								$scope.viewCrisilSum = false;
							}
							if(data.viewCrisilDetails == "Y"){
								$scope.viewCrisilDetails = true;
					  
								}else{
									$scope.viewCrisilDetails = false;
								}
							if(data.viewCrisilCRR == "Y"){
								$scope.viewCrisilCRR = true;
								}else{
									$scope.viewCrisilCRR = false;
					
								}
							if(data.viewCrisilCMA == "Y"){
								$scope.viewCrisilCMA = true;
						
								}else{
									$scope.viewCrisilCMA = false;
								}
							if(data.viewIntrim == "Y"){
								$scope.viewIntrim = true;
						
								}else{
									$scope.viewIntrim = false;
								} 
								
							alert($scope.viewCrisilDetails);
							alert($scope.viewIntrim)
							ProjectionAndFinancialDisplayService.getConsolidatedFlag($scope.companyCode,$scope.viewIntrim,$scope.viewCrisilDetails).then(function(data) {
								$timeout(function(){
									$scope.error=false;
									$scope.data=data;
									alert($scope.data.Status[0]);
									if($scope.data.Status[0]=='B')
										{						
										$scope.IsStandAlone=true;
										$scope.IsConsolidated=true;
										$scope.statusFlag='N';
										}
									else if($scope.data.Status[0]=='C')
										{
										$scope.IsConsolidated=true;
										$scope.IsStandAlone=false;
										$scope.statusFlag='Y';
										}
									else if($scope.data.Status[0]=='S')
										{
										$scope.IsStandAlone=true;
										$scope.IsConsolidated=false;
										$scope.statusFlag='N';
										}					
									else
										{
										$scope.errorMessages="No data is present.";
										}
									
								},100);
								

							}, function(errordata) {
								$scope.error=true;
								$scope.errorMessages="Oops something went wrong while loading  template.";
								//return validationError(true,message);
							});
							
						}, function(errordata) {
							$scope.errorMessages="Error occured";
						});	

			} 
			else {

				// $scope.searchParam1=""
				$scope.error = true;
				$scope.errorMessages="Please select a company from the suggested list.";
				$timeout(function(){

					$scope.error = false;
					$scope.errorMessages = "";

				},2000);
			}

		};	
	}	
	
}
)();